import { mc, MicoJSBridge, getPlatform, getLanguage } from '@mico/mico-base-common';

mc.install(MicoJSBridge);
mc.install(getPlatform);
mc.install(getLanguage);

export default mc;
